import { render, staticRenderFns } from "./adress.vue?vue&type=template&id=84a8362a&scoped=true"
import script from "./adress.vue?vue&type=script&lang=js"
export * from "./adress.vue?vue&type=script&lang=js"
import style0 from "./adress.vue?vue&type=style&index=0&id=84a8362a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a8362a",
  null
  
)

export default component.exports